/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Wrapper function that will cache deterministic outputs given an input
 * the responses are stored based on the input. Thus subsequential requests
 * will be faster.
 *
 * @param func {Function} can be any function that takes a single param as input
 */
export function ProxyCache(func: (param: any) => any) {
  const cache: any = { '1103rm': { lat: 52.3265578, lng: 4.9790392 } };

  return new Proxy(func, {
    apply(target, thisArg, args) {
      const param = args[0];
      if (param in cache) {
        console.log('[[ProxyCache]]');
        return cache[param];
      }
      const result = Reflect.apply(target, thisArg, args);
      cache[param] = result;
      return result;
    },
  });
}
